import { KNOWLEDGEBASE_IOC_TYPES, IOC_TYPES_NEW } from '../constants/iocTypes';

export default {
  disabledConfig: '<strong>Configuration</strong> is disabled',
  startedBy: 'Started by: <strong>{{user}}</strong>',
  durationAgo: '<strong>{{duration}}</strong> ago',
  outOf: 'out of <strong>{{count}}</strong>',
  countSelected: '<strong>{{count}}</strong> selected',
  tooCommonCompanyName:
    '<p>The company name you have provided is too common. To create it <b>without coverage</b> click Continue.</p>' +
    '<p>Alternatively, you can Cancel and change the company name.</p>' +
    '<p>For further asistance, <a>contact our support team</a>.</p>',
  mfaNotice:
    'Activating 2FA (<a>here</a>) is required within the next <strong>{{daysLeft}} days</strong>. Complete the setup now to keep your account safe.',
  maintenanceMessage: {
    snackMsg: 'Scheduled maintenance ({{date}})',
    intro:
      'On <strong>{{date}}</strong>, Cyberint will be conducting a <strong>{{duration}}</strong> on ASM features only.',
    modulesInfo: 'Other modules and features will be working regularly during this time.',
    affectedServicesIntro: 'Services that will be affected during those {{duration}} are:',
    affectedServices: {
      limitedAvailability:
        'ASM features will have limited availability and new tasks such as scans, validation, etc. will not be allowed.',
      addingAssets: 'Adding new assets will not be possible.',
      alertChanges:
        'Alert changes will not be reflected in the Attack Surface Management screen until the maintenance work is completed.'
    },
    apology: 'We are sorry for any inconvenience that this may cause.'
  },
  infinity: {
    genericError:
      '<h1>Something Went Wrong</h1>' +
      '<p>We encountered an issue. Please try logging into ERM again.</p>' +
      '<small>If you need further assistance, contact your Account Manager or <support>Support Team</support></small>',
    tokenError:
      '<h1>Invalid or Expired Token</h1>' +
      '<p>The token is either invalid or expired.<br/>Please refresh the page.</p>',
    ermError:
      '<h1>User Without ERM Role</h1>' +
      '<p>To access ERM, the user must have the ERM Service-Specific Role assigned.</p>' +
      '<ol>' +
      '<li><b>Add the ERM Role</b><br/>' +
      'Ensure the ERM Service-Specific Role is assigned to the user.</li>' +
      '<li><b>Retry Login</b><br/>' +
      'After the role is added, retry log-in.</li>' +
      '</ol>' +
      '<small>If you need further assistance, contact your Infinity Account Manager</small>',
    unAuthError:
      '<h1>Un-Authorized User or IP Address</h1>' +
      '<p>The User or IP Address is not permitted.</p>' +
      '<ol>' +
      '<li><b>Verify User is Enabled</b><br/>' +
      'Verify the user is enabled and well-defined.</li>' +
      '<li><b>Update Allowed IPs</b><br/>' +
      'Try adding 0.0.0.0/0 to the Allowed IPs list to enable access from all IP addresses.</li>' +
      '<li><b>Rety Access</b><br/>' +
      'Once updated, retry log-in.</li>' +
      '</ol>' +
      '<small>If you need further assistance, contact your Account Manager or <support>Support Team</support></small>',
    quotaError:
      '<h1>Insufficient User Quota</h1>' +
      '<p>For this ERM tenant there is not available license to create a new user.</p>' +
      '<small>Contact your ERM admin to review licenses or reach out to your Account Manager for assistance.</small>',
    confirmationWarning:
      '<p>You are about to map <b>Argos Tenant ({{argosTenant}})</b> to <b>Infinity Tenant ({{infinityTenants}})</b></p>' +
      '<p><b>Warning</b>: Incorrect mapping can cause a <b>serious data breach</b>, allowing unauthorized access to customer data.</p>' +
      '<p><b>Are you sure the mapping is correct?</b></p>' +
      '<p><i>If you proceed with incorrect mapping, other customers may gain access to sensitive data.</i></p>'
  },
  assetGroup: {
    usedInAsmOnly:
      'The asset group is used by <asmLink>{{asmCount}} ASM assets</asmLink>. Reassign or unassign them before deleting this group.',
    usedInTiOnly:
      'The asset group is used by <tiLink>{{tiCount}} TI assets</tiLink>. Reassign or unassign them before deleting this group.',
    usedInAsmAndTi:
      'The asset group is used by <asmLink>{{asmCount}} ASM assets</asmLink> and <tiLink>{{tiCount}} TI assets</tiLink>. Reassign or unassign them before deleting this group.'
  },
  editTechModal: {
    noteMessage:
      'Editing this version will automatically close all associated alerts <a>[link to relevant alerts]</a>.',
    deleteNoteMessage:
      'Are you sure you want to delete {{tech}} {{version}}? Deleting this technology will automatically close all associated alerts <a>[link to relevant alerts]</a>.'
  },
  download: {
    download: 'Download',
    started: 'download started',
    completed: 'download completed.',
    success: 'Download Completed.',
    failed: 'Failed to download assets. Please try again.',
    inProgress: 'Download in progress...',
    clickHere: 'Click here to download'
  },
  expired: 'Expired',
  iocType: {
    [KNOWLEDGEBASE_IOC_TYPES.DOMAIN_NAME]: 'Domain',
    [KNOWLEDGEBASE_IOC_TYPES.IPV4_ADDR]: 'IPv4',
    [KNOWLEDGEBASE_IOC_TYPES.SHA256]: 'SHA-256',
    [KNOWLEDGEBASE_IOC_TYPES.SHA_256]: 'SHA-256',
    [KNOWLEDGEBASE_IOC_TYPES.SHA1]: 'SHA-1',
    [KNOWLEDGEBASE_IOC_TYPES.SHA_1]: 'SHA-1',
    [KNOWLEDGEBASE_IOC_TYPES.MD5]: 'MD5',
    [IOC_TYPES_NEW.IPV4]: 'IPv4',
    [IOC_TYPES_NEW.IPV6]: 'IPv6',
    [IOC_TYPES_NEW.DOMAIN]: 'Domain',
    [IOC_TYPES_NEW.URL]: 'URL',
    [IOC_TYPES_NEW.MD5]: 'MD5',
    [IOC_TYPES_NEW.SHA1]: 'SHA-1',
    [IOC_TYPES_NEW.HASH_SHA_256]: 'SHA-256'
  },
  iocTypeGroup: {
    hash: 'Hash',
    ip: 'IP Addresses'
  }
};
